<template>
    <Breadcrumbs main="Users" title="User Cards" />
    <div class="container-fluid">
        <div class="row">
            <userCard />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const userCard = defineAsyncComponent(() => import("@/components/theme/user/cards/userCard.vue"))
</script>